import { map, mergeMap, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import actions, { actionTypes } from "./serviceActions";
import { of } from "rxjs";
import Message from "../../view/shared/message";
import ServiceRxApiService from "../../apiServices/serviceRxApiService";
import i18next from "i18next";

const getServiceEpic = (action$) =>
  action$.pipe(
    ofType(actionTypes.FETCH_INIT),
    mergeMap((_) => {
      return new ServiceRxApiService().get(null, null, "title", "asc").pipe(
        map((response) => {
          return actions.fetchSuccess(response.data.rows, response.data.count);
        }),
        catchError((error) => {
          console.error(error.response.data);
          Message.error(i18next.t("entities.service.messages.fetchError"));
          return of(actions.fetchError());
        })
      );
    })
  );

/**
 * Create user image with or with out image conditional merge
 * @param {*} action$
 */
const createServiceEpic = (action$) =>
  action$.pipe(
    ofType(actionTypes.CREATE_INIT),
    mergeMap((action) =>
      new ServiceRxApiService().create(action.payload.data).pipe(
        mergeMap((_) => {
          Message.success(i18next.t("entities.service.messages.createSuccess"));
          return of(
            actions.createSuccess(),
            actions.initializeFetch(null, "title", "asc", 0)
          );
        }),
        catchError((error) => {
          if (error.response.status === 409) {
            Message.warning(
              i18next.t("entities.service.messages.duplicateError")
            );
          } else {
            Message.error(i18next.t("entities.service.messages.createError"));
          }
          return of(actions.createError());
        })
      )
    )
  );

/**
 * Updates the user with or without image
 * @param {*} action$
 * @param {*} state$
 */
const updateServiceEpic = (action$, state$) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_INIT),
    mergeMap((action) =>
      new ServiceRxApiService().update(action.payload.data).pipe(
        mergeMap((_) => {
          Message.success(i18next.t("entities.service.messages.updatesuccess"));
          return of(
            actions.updateSuccess(),
            actions.initializeFetch(null, "title", "asc", 0)
          );
        }),
        catchError((error) => {
          console.log(error);
          Message.error(i18next.t("entities.service.messages.updateerror"));
          return of(actions.updateError());
        })
      )
    )
  );

const deleteServiceEpic = (action$) =>
  action$.pipe(
    ofType(actionTypes.DELETE_INIT),
    mergeMap((action) =>
      new ServiceRxApiService().delete(action.payload.serviceId).pipe(
        mergeMap((_) => {
          Message.success(i18next.t("entities.service.messages.deleteSuccess"));
          return of(
            actions.deleteSuccess(),
            actions.initializeFetch(null, "title", "asc", 0)
          );
        }),
        catchError((error) => {
          Message.error(i18next.t("entities.service.messages.deleteError"));
          console.error(error);
          return of(actions.deleteError());
        })
      )
    )
  );

export default [
  getServiceEpic,
  createServiceEpic,
  deleteServiceEpic,
  updateServiceEpic,
];
